import { FeedbackConst } from "./feedbackConst";
import { LoggingService } from "../sdServices/loggingSvc";
import { LocalizationService } from "../../ShellCommon/localization/localization";
import { TelemetryService } from "../../ShellCommon/logger/telemetry-service";
import { SdControllerUtilities } from "../sdServices/sd-controller/sd-controller-utilities";
import { HttpTrackingConfig } from "../../ShellCommon/logger/http-interceptor";
import { UserVisibleMessage } from "../sdServices/loggingSvc";
import { ServiceDeskConfig } from "../Startup/serviceDeskConfig";

export class FeedbackController {
  public getTokenInProgress = false;
  // @ngInject
  constructor(
    private feedbackConst: FeedbackConst,
    private $window: ng.IWindowService,
    private $state: ng.ui.IStateService,
    private $http: ng.IHttpService,
    private $q: ng.IQService,
    private loggingService: LoggingService,
    private sdControllerUtilities: SdControllerUtilities,
    private telemetryService: TelemetryService,
    private sdLocalizationService: LocalizationService,
    private sdConfig: ServiceDeskConfig
  ) {}

  public openUserVoice(): ng.IPromise<any> {
    this.getTokenInProgress = true;
    let state = this.$state.current.name;
    let userVoiceUrl = this.getUserVoiceUrl(state);
    return this.getUserVoiceSSOToken().then((token: string) => {
      if (token) {
        this.$window.open(userVoiceUrl + "?sso=" + token, "_blank");
        this.telemetryService.pushAgentFeedbackEvent("", "Feedback in UserVoice");
      }
    });
  }

  private getUserVoiceSSOToken(): ng.IPromise<string> {
    let config: HttpTrackingConfig = this.sdControllerUtilities.getParametersForUserCacheBusting();
    config.dependencyName = "ServiceDesk.SDController";
    config.operationName = "GetSSOToken";
    config.dependencyOperationName = "UserVoiceFeedback.Token";

    let url = "SDController/api/UserVoiceFeedback/token";
    return this.$http
      .get(this.sdConfig.sdBaseUrl + url, config)
      .then((success) => {
        this.getTokenInProgress = false;
        return <string>success.data;
      })
      .catch((failure) => {
        let errorMessage = this.sdLocalizationService.getLocalizedString("ServiceDesk", "_FEEDBACK_ERROR_MESSAGE_");
        this.loggingService.logError("Could not get uservoice sso token", failure, <UserVisibleMessage>{
          displayText: errorMessage
        });
        this.getTokenInProgress = false;
        return this.$q.reject(errorMessage);
      });
  }

  private getUserVoiceUrl(state: string): string {
    let area = undefined;
    let currentState = state;
    // Check current state and then parent's state
    while (area === undefined && currentState && currentState.length > 0) {
      area = this.feedbackConst.experienceAreas[currentState];
      currentState = currentState.substring(0, currentState.lastIndexOf("."));
    }
    // Use default
    if (area === undefined) {
      area = this.feedbackConst.experienceAreas["default"];
    }
    return area;
  }
}
